import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'
import ActionInfluencerItem from './ActionInfluencerItem'

export default observer(function InfluencersList() {
  const { draftInfluencers } = useContext(SharedCampaignContext)

  return (
    <div>{ draftInfluencers.map(inf => <ActionInfluencerItem key={inf.id} influencer={inf} />)}</div>
  )
})
